import { Appointment } from "@elixir/types";
import { PastVisitUi } from "ui";

const PastVisit = ({
  apt,
  className = "dr-col-span-2",
}: {
  apt: Appointment;
  className?: string;
}) => {
  const { last_visit_time, visit_count = 0 } = apt || {};

  return null;

  // return (
  //   <PastVisitUi
  //     lastVisitTime={last_visit_time}
  //     visitCount={visit_count}
  //     className={className}
  //   />
  // );
};

export default PastVisit;
